export default __webpack_public_path__ + "static/media/back_arrow.650a3a0a.svg";